import React from 'react'
import { Banner , Categories , NewEdition } from "../component/index"
function Home() {
    return (
        <>
        <Banner />
        <Categories />
        <NewEdition />
        </>
            
    )
}
export default Home;

